'use strict';
function time(dateTimeStamp) {
  var result;
  var second = 1000;
  var minute = 60000; // 1000 * 60
  var now = new Date().getTime();
  var end = new Date(dateTimeStamp.replace(/-/g, "/")).getTime();
  var diffValue = now - end;
  // if (diffValue < 0) {
  //   // return now + "=" + end;
  //   return;
  // }
  var minC = diffValue / minute;
  var secC = diffValue / second;
  if (secC < 60) {
    // result = "" + parseInt(secC) + "秒前"
    result = "刚刚";
  }
  else if (minC >= 1 && minC < 60) {
    result = "" + parseInt(minC) + "分钟前";
  }
  else {
    result = dateTimeStamp.slice(5, 16);
  }
  return result;
}

exports.time = time;



// WEBPACK FOOTER //
// ./static/util/time.js